import { SVGIcons } from './SVGIcons';

export interface SvgProps {
  activeColor?: string;
  canUseDarkMode?: boolean;
  className?: string;
  color?: string;
  fill?: boolean;
  hoverColor?: string;
  isActive?: boolean;
  id?: string;
  svgName: keyof typeof SVGIcons;

  onClick?(param?: any): any;
}

export const Icon = ({
  activeColor,
  className = '',
  color,
  fill = true,
  hoverColor,
  id = '',
  isActive,
  svgName,
  onClick,
  canUseDarkMode = true,
}: SvgProps) => {
  className += `
    ${fill && 'fill-current'}
    ${hoverColor && !isActive && `hover:text-${hoverColor}`}
    ${
      isActive
        ? `text-${activeColor} dark:text-grey-50 pointer-events-none`
        : color && `text-${color}`
    }
    ${canUseDarkMode && 'dark:text-white'}
  `;

  const svgElement = { ...SVGIcons[svgName] };

  // add necessary attributes
  svgElement.props = {
    ...svgElement.props,
    className,
    ...(id ? { id } : {}),
    ...(onClick && { onClick }),
  };

  return svgElement;
};
